import { mapActions, mapGetters } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'

export const FormatSettingTimeCacheMixin = {
  mixins: [SelectedSiteIdMixin],
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapGetters('FormatSettingTime', [
      'findTimeFormatSettingCache'
    ]),
    timeFormatSettingCache () {
      return this.findTimeFormatSettingCache(this.selectedSiteId)
    },
    timeFormatSetting () {
      return this.timeFormatSettingCache ? this.timeFormatSettingCache.value : null
    },
    loadingTimeFormatSetting () {
      return !!this.timeFormatSettingCache && this.timeFormatSettingCache.loading
    }
  },
  watch: {
    selectedSiteId () {
      this.refreshTimeFormatSetting()
    }
  },
  methods: {
    ...mapActions('FormatSettingTime', [
      'fetchTimeFormatSettingBySiteId'
    ]),
    refreshTimeFormatSetting () {
      if (!this.timeFormatSettingCache || this.timeFormatSettingCache.retry) {
        this.tryFetchTimeFormatSettingBySiteId()
      }
    },
    tryFetchTimeFormatSettingBySiteId () {
      const self = this
      if (!self.selectedSiteId) {
        return
      }
      self.error = ''
      self.fetchTimeFormatSettingBySiteId(self.selectedSiteId)
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshTimeFormatSetting()
  }
}
